import { useMatch } from 'react-router';
import { IWhitePaperReport } from '../model/iWhitePaperReport';

// determines if the current route contains the cell comments subroute
// if it does, it creates an object with the comment data needed to show the comments panel
// example 1 (no commentId): /view/51/cell/FD0P_0/10500/comments
// example 2 (with commentId): /view/51/cell/FD0P_0/10500/comments/d158053e-72b9-4c3a-bb3e-dad621e65daf
// example 3 (opened from a form): /view/51/forms/some-toc-item-id/cell/FD0P_0/10500/comments
export const useCellCommentsRouteDetails = (currentReport: IWhitePaperReport | undefined) => {
    const bareMatch = useMatch('/view/:id/cell/:columnId/:rowId/:subroute?/:cellCommentId?');
    // Comments opened from a form field keep the /forms/:tocItemId prefix in the URL so the
    // form stays displayed underneath the panel (formViewContext's showForm is regex-derived
    // from the pathname starting with /forms) — the bare pattern above alone won't match it.
    const formsMatch = useMatch('/view/:id/forms/:tocItemId/cell/:columnId/:rowId/:subroute?/:cellCommentId?');
    const match = bareMatch ?? formsMatch;

    if (currentReport && match?.params) {
        const { subroute, rowId, columnId } = match.params;

        if (subroute && rowId && columnId && subroute.toLocaleLowerCase() === 'comments') {
            const rowData = currentReport.rows?.find((r) => r.displayRowNumber === rowId);

            if (rowData) {
                return { isCommentsSubroute: true, commentData: { rowData, columnName: columnId } };
            }
        }
    }

    return { isCommentsSubroute: false, commentData: undefined };
};
